/* EXC cart drawer: shipping protection switch (<exc-shipping-protection>,
   markup in snippets/cart-details.liquid)
   On adds the protection product to the cart through the theme's cart store,
   off removes it, and the whole drawer redraws either way. The switch follows
   the cart, so it is on whenever the product is in the cart, however it got
   there, and it keeps the line at a quantity of one.
   If protection is ever the only thing left in the cart (every product taken
   out), it is removed too, so nobody checks out paying for protection alone.
   Counts and the free shipping total leave the line out: window.excCart in
   layout/theme.liquid. Styles: assets/exc-shipping-protection.css.
   Notes: hq/projects/excdesigns/theme-build-notes.md */
(function () {
  if (customElements.get('exc-shipping-protection')) return;

  var storePromise = null;
  function store() {
    if (!storePromise) storePromise = import('cart-store').then(function (m) { return m.default; });
    return storePromise;
  }

  var cleaning = false;

  class ExcShippingProtection extends HTMLElement {
    connectedCallback() {
      this.variantId = Number(this.getAttribute('variant-id'));
      this.input = this.querySelector('.exc-protect__input');
      if (!this.variantId || !this.input) return;

      this.onChange = this.onChange.bind(this);
      this.input.addEventListener('change', this.onChange);

      var self = this;
      store().then(function (Cart) {
        self.Cart = Cart;
        self.sync(Cart.getState().cart);
        self.unsubscribe = Cart.subscribe(function (state) { self.sync(state.cart); });
      }).catch(function () {});
    }

    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
    }

    lines(cart) {
      var id = this.variantId;
      return (cart.items || []).filter(function (i) { return i.variant_id === id; });
    }

    sync(cart) {
      if (!cart || !cart.items) return;
      var lines = this.lines(cart);
      var others = cart.items.length - lines.length;

      if (!this.classList.contains('is-busy')) this.input.checked = lines.length > 0;

      if (cleaning || !this.Cart || lines.length === 0) return;

      var updates = null;
      if (others === 0) {
        // Protection alone in the cart: take it out
        updates = {};
        lines.forEach(function (l) { updates[l.key] = 0; });
      } else if (lines.length > 1 || lines[0].quantity !== 1) {
        // Keep exactly one protection line
        updates = {};
        lines.forEach(function (l, i) { updates[l.key] = i === 0 ? 1 : 0; });
      }
      if (updates) {
        cleaning = true;
        this.Cart.update({ updates: updates }).catch(function () {}).then(function () { cleaning = false; });
      }
    }

    onChange() {
      var self = this;
      var turnOn = this.input.checked;
      this.classList.add('is-busy');
      this.input.disabled = true;

      store().then(function (Cart) {
        var cart = Cart.getState().cart;
        var lines = self.lines(cart);
        if (turnOn) {
          if (lines.length) return null;
          return Cart.add([{ id: self.variantId, quantity: 1 }]);
        }
        var updates = {};
        lines.forEach(function (l) { updates[l.key] = 0; });
        return lines.length ? Cart.update({ updates: updates }) : null;
      }).catch(function () {
        self.input.checked = !turnOn;
      }).then(function () {
        self.classList.remove('is-busy');
        self.input.disabled = false;
        if (self.Cart) self.sync(self.Cart.getState().cart);
      });
    }
  }

  customElements.define('exc-shipping-protection', ExcShippingProtection);
})();
